import { render, staticRenderFns } from "./ManufactureProductPropsModal.vue?vue&type=template&id=7d64140e&"
import script from "./ManufactureProductPropsModal.vue?vue&type=script&lang=js&"
export * from "./ManufactureProductPropsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports